import { CategoryItem } from '../categories/category-item.model';
import { AppTeamUtil } from '../../core/app-team-util';

export class MemberInfo
{
    Id!: number;
    CanUploadMedia = false;
    CanDeleteMedia = false;
    MembershipNumber?: string;
    MembershipTypeId?: number;
    StartDate?: Date;
    RenewalDate?: Date;
    ShouldDisplayInDirectory = false;
    ShouldReceivePushNotifications = false;
    ShouldReceiveEmailNotifications = false;
    ShouldReceiveSmsNotifications = false;
    ShouldViewSocialMedia = false;
    CategoryItems: CategoryItem[] = [];

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json['CategoryItems']) this.CategoryItems = json['CategoryItems'].map((item: any) => new CategoryItem(item));
            this.StartDate = AppTeamUtil.convertApiDateStringToDate(json['StartDate']);
            this.RenewalDate = AppTeamUtil.convertApiDateStringToDate(json['RenewalDate']);

            delete (this as any)['MemberId'];
            delete (this as any)['MyEvents'];
        }
    }
}
